import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/common.scss'
import './style/mobile.scss'
import './style/pc.scss'
import 'animate.css'
import VueLazyload from 'vue-lazyload'
// import { IsMobile } from './utils'
import http from './http.js'
Vue.prototype.$https = http
Vue.use(VueLazyload)

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  listenEvents: [ 'scroll' ]
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
